import { AnimatePresence, motion, type MotionValue } from "motion/react";
import type { ReactNode } from "react";

type RuntimeMotionTransformImageProps = {
  alt: string;
  rotate: MotionValue<number>;
  scale: MotionValue<number>;
  src: string;
  x: MotionValue<number>;
  y: MotionValue<number>;
};

export function MediaLayoutGroup({ children }: { children: ReactNode }): ReactNode {
  return <AnimatePresence>{children}</AnimatePresence>;
}

/** Keeps Motion's shared-layout projection element out of product composition. */
export function MediaLayoutOverlay({ layoutId }: { layoutId: string }): ReactNode {
  return <motion.div className="absolute inset-0" layoutId={layoutId} />;
}

/** Applies live Motion transform values without exposing Motion's style API to product composition. */
export function RuntimeMotionTransformImage({
  alt,
  rotate,
  scale,
  src,
  x,
  y,
}: RuntimeMotionTransformImageProps): ReactNode {
  return (
    <motion.img
      src={src}
      alt={alt}
      className="size-full object-cover select-none"
      draggable={false}
      style={{ x, y, scale, rotate }}
    />
  );
}
